import Api, {
  baseURL,
  requestOptionsGET,
  requestOptionsPOST,
  requestOptionsDELETE,
  requestOptionsDELETEWithBody
} from '../api';
import newFetch from '../utils/newFetch';

const state = {
  cargos: [],
  unallocatedStops: []
};

const getters = {
  getCargos: (state) => state.cargos,
  getUnallocatedNfes: (state) => state.unallocatedStops
};

const mutations = {
  setDeliveriesByid(state, payload) {
    state.cargos = payload;
  },
  setUnallocatedStopsByid(state, payload) {
    state.unallocatedStops = payload;
  },
  setTranshipmentByCityid(state, payload) {
    state.transhipmentByCity = payload;
  }
};

const actions = {
  getAllCargos(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getCargosManualBoarding + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then(({ data }) => {
          context.commit('setDeliveriesByid', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  getAllUnallocatedStops(context, processId) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getUnallocatedStops + processId, requestOptionsGET(localStorage.getItem('accessToken')))
        .then(({ data }) => {
          context.commit('setUnallocatedStopsByid', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createNewCargo(_, model) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.createCargoManualBoarding + model.processId,
        requestOptionsPOST(localStorage.getItem('accessToken'), {
          isDirectDelivery: model.isDirectDelivery,
          cityId: model.cityId || 0
        })
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  createGroupedCargos(_, model) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.createGroupedCargos + model.processId,
        requestOptionsPOST(localStorage.getItem('accessToken'), {
          stopsIds: model.stopsIds
        })
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getStopsByCargoId(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getStopsByCargoIdManualBoarding + id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  allocateStop(_, params) {
    const body = {
      stopsIds: params.stopsIds
    };
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.allocateStopsManualBoarding + params.id,
        requestOptionsPOST(localStorage.getItem('accessToken'), body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deallocateStop(_, params) {
    const body = {
      stopsIds: params.stopsIds
    };
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.deallocateStopsManualBoarding + params.id,
        requestOptionsPOST(localStorage.getItem('accessToken'), body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deleteCargo(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.deleteCargoManualBoarding + id, requestOptionsDELETE(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => {
          reject(err);
          return err;
        });
    });
  },
  deleteMultipleCargos(_, ids) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.deleteMultipleCargosManualBoarding,
        requestOptionsDELETEWithBody(localStorage.getItem('accessToken'), { cargosIds: ids })
      )
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => {
          reject(err);
          return err;
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
